// extracted by mini-css-extract-plugin
export var Footer = "Footer-module--Footer--f9978";
export var FooterContact = "Footer-module--FooterContact--63a20";
export var FooterLink = "Footer-module--FooterLink--b5d97";